// src/utils/rtl.ts
export const RTL_LANGUAGES = ['ar', 'ur', 'he', 'fa'];

export const isRTLLanguage = (language: string): boolean => {
  return RTL_LANGUAGES.includes(language);
};

export const getDirection = (language: string): 'ltr' | 'rtl' => {
  return isRTLLanguage(language) ? 'rtl' : 'ltr';
};

export const getTextAlign = (language: string): 'left' | 'right' => {
  return isRTLLanguage(language) ? 'right' : 'left';
};
